<template>
    <v-app>
        <Drawer />
        <Toolbar />
        <v-content>
            <v-container fluid :class="{'pa-1': $vuetify.breakpoint.mdAndDown, 'pa-4': $vuetify.breakpoint.mdAndUp}">
                <notifications app position="bottom center" max-width="40%" />
                <transition name="fade" mode="out-in">
                    <router-view>

                    </router-view>
                </transition>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import Drawer from '@/components/Shared/Drawer'
import Toolbar from '@/components/Shared/Toolbar'
import {FCM} from '@capacitor-community/fcm';
import {PushNotifications} from '@capacitor/push-notifications';


export default {
    name: 'App',
    components: {
        Drawer,
        Toolbar
    },
    data() {
        return {
            playing:false,
        }
    },
    beforeMount () {
        this.$store.watch((state) => {
            return this.$store.state.user.language
        }, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (this.$store.state.user.language) {
                    this.$i18n.locale = this.$store.state.user.language
                }
            }
        })
        this.$store.watch((state) => {
            return this.$store.state.auth.token
        }, (newValue, oldValue) => {
            if (!newValue && oldValue !== null) {
                this.$router.push('/')
                this.$notify({
                    group: 'default',
                    type: 'warning',
                    title: this.$t('alerts.expired.title'),
                    text: this.$t('alerts.expired.text')
                })
            }
        })
        this.$router.beforeResolve((to, from, next) => {
            if (!this.$store.state.auth.token && to.meta.secure === true) {
                this.$router.push('/')
            } else if (this.$store.state.auth.token && to.meta.secure === false) {
                this.$router.push('/dashboard')
            } else {
                next()
            }
        })
        this.$router.afterEach((to, from) => {
            document.title = this.$store.state.app.title + ' | ' + this.$t('views.' + to.meta.title)
        })
    },
    async mounted(){
        let vm =this;
        PushNotifications.addListener('registration',
          (Token) => {
            console.log("FCM token received: "+Token.value)
            window.localStorage.setItem("fcm_token",Token.value);
          }
        );
        
        await PushNotifications.requestPermissions();
        await PushNotifications.register();

        // Enable the auto initialization of the library
        FCM.setAutoInit({ enabled: true }).then(() => console.log(`Auto init enabled`));
    }
}
</script>
<style>
    @import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons');
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }
    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
    a{
        max-width: 100%;
        overflow-wrap: break-word;
    }
    p{
        font-size:16px;    
        max-width: 100%;
    }
    h1{
        text-transform: uppercase;
    }
    .layout{
        padding:20px;
    }
    .v-navigation-drawer .layout{
        padding:0;
    }
    h1,h2,h3{
        min-width:100%;
    }
    .v-expansion-panel__header{
        background: #209ecc;
        color: white;
    }
    .theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{
        color:white;
    }
    .v-card__title{
        display: block;
        text-align: center;
    }
    .v-card__text{
        text-align: justify;
    }
    main{
        margin-top:env(safe-area-inset-top)!important;
    }
    nav{
        padding-top:env(safe-area-inset-top)!important;
    }
    aside{
        margin-top:calc(48px + env(safe-area-inset-top))!important;
    }
    .v-card{
        margin-bottom:10px;
        border-radius:8px;
        cursor:pointer;
    }
    .v-dialog{
        font-size:16px;
    }
    .v-dialog .v-card{
        margin-bottom:0;
    }
    .field-title{
        font-weight: 500;
        display:inline-block;
        text-align:left;
        min-width:170px;
        font-size:16px;
    }
    .field-value{
        font-size:16px;
        text-align:left;
        min-width: calc(100% - 170px);
    }
    .overflow-y-hidden main{
        margin-left:200px;
    }
    .v-toolbar{
        box-shadow: none;
    }
    .v-btn--floating.v-btn--absolute{
        position: fixed;
    }
    .container{
        padding:10px;
    }
    .v-card.selected{
        background:#4caf50;
        color:white;
    }
    .not-multiselecting .card-checkbox{
        display: none;
    }
    .card-checkbox{
        float:left;
        display: inline;
        position: relative;
        left:-10px;
        margin:20px;
    }
    .card-checkbox i{
        font-size:0;
        border:3px solid gray;
        padding:10px;
        position: relative;
    }
    .selected .card-checkbox i{
        color:white!important;
        border:none;
        font-size:40px;
        left:0;
        padding: 0;
        left:-5px;
    }
    .inline-block{
        display: inline-block;
    }
    .card-chev {
        border-right:10px solid black;
        border-bottom:10px solid black;
        width:30px;
        height:30px;
        transform: rotate(-45deg);
        border-color:#00000038;
        float: right;
        margin-top:25px;
    }
    .results-count{
        text-align:right;
    }
    .ec-now-indicator{
        z-index:90!important;
    }
    .ec-event{
        color:black!important;
        cursor:pointer;
    }
    .accent--text {
        color: #2196F3 !important;
        caret-color: #82b1ff !important;
    }
</style>
